import LegalLayout from "./LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-serif text-2xl md:text-3xl text-charcoal mt-12 mb-4 leading-tight">{children}</h2>
);
const H3 = ({ children }) => (
  <h3 className="font-serif text-xl text-umber mt-8 mb-3">{children}</h3>
);
const H4 = ({ children }) => (
  <h4 className="font-display tracking-[0.22em] text-[11px] uppercase text-umber mt-6 mb-2">{children}</h4>
);
const P = ({ children }) => (
  <p className="font-serif text-base md:text-lg text-charcoal leading-relaxed">{children}</p>
);
const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 font-serif text-base md:text-lg text-charcoal leading-relaxed">
    {children}
  </ul>
);

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <div className="space-y-6">
        <H2>Präambel</H2>
        <P>
          Mit der folgenden Datenschutzerklärung möchten wir Sie darüber aufklären, welche Arten Ihrer
          personenbezogenen Daten (nachfolgend auch kurz als „Daten" bezeichnet) wir zu welchen Zwecken
          und in welchem Umfang verarbeiten. Die Datenschutzerklärung gilt für alle von uns durchgeführten
          Verarbeitungen personenbezogener Daten, sowohl im Rahmen der Erbringung unserer Leistungen als
          auch insbesondere auf unseren Webseiten, in mobilen Applikationen sowie innerhalb externer
          Onlinepräsenzen, wie z. B. unserer Social-Media-Profile (nachfolgend zusammenfassend bezeichnet
          als „Onlineangebot").
        </P>
        <P>Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</P>
        <P>Stand: 4. Juli 2026</P>

        <H2>Verantwortlicher</H2>
        <div className="bg-paper rounded-2xl p-6 md:p-8 my-2">
          <P>
            S. Dreier<br />
            Saritscher Hauptstraße 12<br />
            02699 Neschwitz
          </P>
          <P>
            E-Mail-Adresse:{" "}
            <a href="mailto:hallo@oratiorede.de" className="underline underline-offset-4 text-umber hover:text-charcoal">
              hallo@oratiorede.de
            </a>
            <br />
            Kontaktformular:{" "}
            <a href="/kontakt" className="underline underline-offset-4 text-umber hover:text-charcoal">
              /kontakt
            </a>
          </P>
        </div>

        <H2>Übersicht der Verarbeitungen</H2>
        <P>
          Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer
          Verarbeitung zusammen und verweist auf die betroffenen Personen.
        </P>

        <H4>Arten der verarbeiteten Daten</H4>
        <UL>
          <li>Bestandsdaten</li>
          <li>Zahlungsdaten</li>
          <li>Kontaktdaten</li>
          <li>Inhaltsdaten</li>
          <li>Vertragsdaten</li>
          <li>Nutzungsdaten</li>
          <li>Meta-, Kommunikations- und Verfahrensdaten</li>
          <li>Protokolldaten</li>
        </UL>

        <H4>Kategorien betroffener Personen</H4>
        <UL>
          <li>Leistungsempfänger und Auftraggeber</li>
          <li>Interessenten</li>
          <li>Kommunikationspartner</li>
          <li>Nutzer</li>
          <li>Geschäfts- und Vertragspartner</li>
        </UL>

        <H4>Zwecke der Verarbeitung</H4>
        <UL>
          <li>Erbringung vertraglicher Leistungen und Erfüllung vertraglicher Pflichten</li>
          <li>Kommunikation</li>
          <li>Sicherheitsmaßnahmen</li>
          <li>Büro- und Organisationsverfahren</li>
          <li>Feedback</li>
          <li>Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit</li>
          <li>Informationstechnische Infrastruktur</li>
          <li>Geschäftsprozesse und betriebswirtschaftliche Verfahren</li>
        </UL>

        <H2>Maßgebliche Rechtsgrundlagen</H2>
        <P>
          <strong>Maßgebliche Rechtsgrundlagen nach der DSGVO:</strong> Im Folgenden erhalten Sie eine
          Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten
          verarbeiten. Bitte nehmen Sie zur Kenntnis, dass neben den Regelungen der DSGVO nationale
          Datenschutzvorgaben in Ihrem bzw. unserem Wohn- oder Sitzland gelten können. Sollten ferner
          im Einzelfall speziellere Rechtsgrundlagen maßgeblich sein, teilen wir Ihnen diese in der
          Datenschutzerklärung mit.
        </P>
        <UL>
          <li>
            <strong>Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO)</strong> — Die betroffene Person hat
            ihre Einwilligung in die Verarbeitung der sie betreffenden personenbezogenen Daten für einen
            spezifischen Zweck oder mehrere bestimmte Zwecke gegeben.
          </li>
          <li>
            <strong>Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO)</strong>
            {" "}— Die Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene
            Person ist, oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, die auf Anfrage
            der betroffenen Person erfolgen.
          </li>
          <li>
            <strong>Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO)</strong> — Die
            Verarbeitung ist zur Erfüllung einer rechtlichen Verpflichtung erforderlich, der der
            Verantwortliche unterliegt.
          </li>
          <li>
            <strong>Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO)</strong> — Die
            Verarbeitung ist zur Wahrung der berechtigten Interessen des Verantwortlichen oder eines
            Dritten notwendig, vorausgesetzt, dass die Interessen, Grundrechte und Grundfreiheiten der
            betroffenen Person, die den Schutz personenbezogener Daten verlangen, nicht überwiegen.
          </li>
        </UL>
        <P>
          <strong>Nationale Datenschutzregelungen in Deutschland:</strong> Zusätzlich zu den
          Datenschutzregelungen der DSGVO gelten nationale Regelungen zum Datenschutz in Deutschland.
          Hierzu gehört insbesondere das Gesetz zum Schutz vor Missbrauch personenbezogener Daten bei
          der Datenverarbeitung (Bundesdatenschutzgesetz – BDSG). Ferner können Landesdatenschutzgesetze
          der einzelnen Bundesländer zur Anwendung gelangen.
        </P>

        <H2>Sicherheitsmaßnahmen</H2>
        <P>
          Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter Berücksichtigung des Stands der
          Technik, der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der
          Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der
          Bedrohung der Rechte und Freiheiten natürlicher Personen geeignete technische und
          organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.
        </P>
        <P>
          Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und
          Verfügbarkeit von Daten durch Kontrolle des physischen und elektronischen Zugangs zu den
          Daten als auch des sie betreffenden Zugriffs, der Eingabe, der Weitergabe, der Sicherung der
          Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine
          Wahrnehmung von Betroffenenrechten, die Löschung von Daten und Reaktionen auf die Gefährdung
          der Daten gewährleisten. Ferner berücksichtigen wir den Schutz personenbezogener Daten bereits
          bei der Entwicklung bzw. Auswahl von Hardware, Software sowie Verfahren entsprechend dem
          Prinzip des Datenschutzes durch Technikgestaltung und durch datenschutzfreundliche
          Voreinstellungen.
        </P>
        <P>
          <strong>Sicherung von Online-Verbindungen durch TLS-/SSL-Verschlüsselungstechnologie (HTTPS):</strong>{" "}
          Um die Daten der Nutzer, die über unsere Online-Dienste übertragen werden, vor unerlaubten
          Zugriffen zu schützen, setzen wir auf die TLS-/SSL-Verschlüsselungstechnologie. Wenn eine
          Website durch ein SSL-/TLS-Zertifikat gesichert ist, wird dies durch die Anzeige von HTTPS in
          der URL signalisiert.
        </P>

        <H2>Internationale Datentransfers</H2>
        <P>
          <strong>Datenverarbeitung in Drittländern:</strong> Sofern wir Daten in ein Drittland (d. h.
          außerhalb der Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) übermitteln
          oder dies im Rahmen der Nutzung von Diensten Dritter oder der Offenlegung bzw. Übermittlung
          von Daten an andere Personen, Stellen oder Unternehmen geschieht, erfolgt dies stets im
          Einklang mit den gesetzlichen Vorgaben.
        </P>
        <P>
          Für Datenübermittlungen in die USA stützen wir uns vorrangig auf das Data Privacy Framework
          (DPF), welches durch einen Angemessenheitsbeschluss der EU-Kommission vom 10.07.2023 als
          sicherer Rechtsrahmen anerkannt wurde. Zusätzlich haben wir mit den jeweiligen Anbietern
          Standardvertragsklauseln abgeschlossen, die den Vorgaben der EU-Kommission entsprechen und
          vertragliche Verpflichtungen zum Schutz Ihrer Daten festlegen.
        </P>
        <P>
          Weitere Informationen zum DPF und eine Liste der zertifizierten Unternehmen finden Sie auf
          der Website des US-Handelsministeriums unter{" "}
          <a
            href="https://www.dataprivacyframework.gov/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://www.dataprivacyframework.gov/
          </a>
          .
        </P>

        <H2>Allgemeine Informationen zur Datenspeicherung und Löschung</H2>
        <P>
          Wir löschen personenbezogene Daten, die wir verarbeiten, gemäß den gesetzlichen Bestimmungen,
          sobald die zugrundeliegenden Einwilligungen widerrufen werden oder keine weiteren rechtlichen
          Grundlagen für die Verarbeitung bestehen. Ausnahmen bestehen, wenn gesetzliche Pflichten oder
          besondere Interessen eine längere Aufbewahrung oder Archivierung der Daten erfordern.
        </P>
        <P>
          <strong>Aufbewahrungsfristen nach deutschem Recht:</strong>
        </P>
        <UL>
          <li>
            <strong>10 Jahre</strong> — Bücher und Aufzeichnungen, Jahresabschlüsse, Inventare,
            Lageberichte, Eröffnungsbilanz sowie die zu ihrem Verständnis erforderlichen Arbeitsanweisungen
            und sonstigen Organisationsunterlagen (§ 147 AO, § 14b UStG, § 257 HGB).
          </li>
          <li>
            <strong>8 Jahre</strong> — Buchungsbelege, wie z. B. Rechnungen und Kostenbelege
            (§ 147 AO, § 257 HGB).
          </li>
          <li>
            <strong>6 Jahre</strong> — Übrige Geschäftsunterlagen: empfangene Handels- oder
            Geschäftsbriefe, sonstige Unterlagen, soweit sie für die Besteuerung von Bedeutung sind.
          </li>
          <li>
            <strong>3 Jahre</strong> — Daten für potenzielle Gewährleistungs- und Schadensersatzansprüche,
            gemäß der regulären gesetzlichen Verjährungsfrist (§§ 195, 199 BGB).
          </li>
        </UL>

        <H2>Rechte der betroffenen Personen</H2>
        <P>
          Ihnen stehen als Betroffene nach der DSGVO verschiedene Rechte zu, die sich insbesondere aus
          Art. 15 bis 21 DSGVO ergeben:
        </P>
        <UL>
          <li>
            <strong>Widerspruchsrecht:</strong> Sie haben das Recht, aus Gründen, die sich aus Ihrer
            besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden
            personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt,
            Widerspruch einzulegen.
          </li>
          <li>
            <strong>Widerrufsrecht bei Einwilligungen:</strong> Sie haben das Recht, erteilte
            Einwilligungen jederzeit zu widerrufen.
          </li>
          <li>
            <strong>Auskunftsrecht:</strong> Sie haben das Recht, eine Bestätigung darüber zu verlangen,
            ob betreffende Daten verarbeitet werden und auf Auskunft über diese Daten sowie auf weitere
            Informationen und Kopie der Daten.
          </li>
          <li>
            <strong>Recht auf Berichtigung:</strong> Sie haben das Recht, die Vervollständigung oder
            Berichtigung der Sie betreffenden Daten zu verlangen.
          </li>
          <li>
            <strong>Recht auf Löschung und Einschränkung der Verarbeitung:</strong> Sie haben das Recht,
            zu verlangen, dass Sie betreffende Daten unverzüglich gelöscht werden.
          </li>
          <li>
            <strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Sie betreffende Daten
            in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
          </li>
          <li>
            <strong>Beschwerde bei Aufsichtsbehörde:</strong> Sie haben das Recht auf Beschwerde bei
            einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts.
          </li>
        </UL>

        <H2>Geschäftliche Leistungen</H2>
        <P>
          Wir verarbeiten personenbezogene Daten unserer Vertrags- und Geschäftspartner, etwa Kunden,
          Auftraggeber, Interessenten, Lieferanten und sonstige Kooperationspartner (zusammenfassend
          „Vertragspartner"), zur Anbahnung, Durchführung und Abwicklung von Vertragsverhältnissen
          sowie vergleichbaren Rechtsverhältnissen.
        </P>
        <P>
          Verarbeitet werden insbesondere Stammdaten wie Name, Anschrift und ggf. Firma, Kontaktdaten
          wie E-Mail-Adresse und Telefonnummer, Vertrags- und Leistungsdaten wie Vertragsgegenstand,
          Vertragslaufzeit, Bestell- oder Vorgangsnummer, Nutzungs- und Leistungsdaten, Zahlungs- und
          Abrechnungsdaten sowie Kommunikationsinhalte und -historien.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO); Rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO);
          Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
        </P>

        <H3>Bestellformulare, E-Commerce und Leistungserfüllung</H3>
        <P>
          Wir verarbeiten die Daten unserer Kunden, um ihnen die Bestellung des gewünschten Trauerrede-
          Entwurfs sowie dessen Bezahlung und Bereitstellung zu ermöglichen. Die erforderlichen Angaben
          sind als solche im Rahmen des Bestell- bzw. Erwerbsvorgangs gekennzeichnet und umfassen die
          zur Ausführung und Abrechnung benötigten Angaben sowie Kontaktinformationen, um etwaige
          Rücksprache halten zu können. Rechtsgrundlagen: Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO).
        </P>

        <H3>KI-gestützte Textgenerierung</H3>
        <P>
          Zur Erstellung Ihres Trauerrede-Entwurfs übermitteln wir die von Ihnen im Generator-Formular
          eingegebenen Inhalte (z. B. Rolle, Name und Lebensdaten der verstorbenen Person, Familien-
          und Lebensdetails, Persönlichkeitsmerkmale, persönliche Erinnerungen) an unseren KI-Dienstleister
          Anthropic, um die automatisierte Erstellung des Entwurfs zu ermöglichen. Die Übermittlung
          erfolgt ausschließlich zur Erfüllung des mit Ihnen geschlossenen Vertrags und wird nach der
          Erzeugung des Entwurfs nicht dauerhaft bei uns gespeichert.
        </P>
        <P>
          <strong>Dienstanbieter:</strong> Anthropic PBC, 548 Market Street, PMB 90375, San Francisco,
          CA 94104, USA.
          <br />
          <strong>Website:</strong>{" "}
          <a
            href="https://www.anthropic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://www.anthropic.com
          </a>
          <br />
          <strong>Datenschutzerklärung:</strong>{" "}
          <a
            href="https://www.anthropic.com/legal/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://www.anthropic.com/legal/privacy
          </a>
          <br />
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO).
          <br />
          <strong>Grundlage Drittlandtransfers:</strong> Standardvertragsklauseln der EU-Kommission.
        </P>

        <H2>Zahlungsverfahren</H2>
        <P>
          Im Rahmen von Vertrags- und sonstigen Rechtsbeziehungen bieten wir den betroffenen Personen
          effiziente und sichere Zahlungsmöglichkeiten an und setzen hierzu neben Banken und
          Kreditinstituten weitere Dienstleister ein (zusammenfassend „Zahlungsdienstleister"). Der
          Zahlungsverkehr erfolgt dabei entsprechend dem Stand der Technik ausschließlich über
          verschlüsselte Verbindungen, sodass die eingegebenen Daten während der Übermittlung vor
          unbefugtem Zugriff geschützt sind.
        </P>
        <P>
          Zu den durch die Zahlungsdienstleister verarbeiteten Daten gehören Bestandsdaten,
          Kreditkartennummern, Passwörter, TANs und Prüfsummen sowie die Vertrags-, Summen- und
          empfängerbezogenen Angaben. Wir erhalten keine konto- oder kreditkartenbezogenen Informationen,
          sondern lediglich Informationen mit Bestätigung oder Negativbeauskunftung der Zahlung.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO); Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
        </P>

        <H3>Stripe</H3>
        <P>
          Zahlungsdienstleistungen (technische Anbindung von Online-Bezahlmethoden).
        </P>
        <P>
          <strong>Dienstanbieter:</strong> Stripe, Inc., 510 Townsend Street, San Francisco, CA 94103,
          USA.
          <br />
          <strong>Website:</strong>{" "}
          <a
            href="https://stripe.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://stripe.com
          </a>
          <br />
          <strong>Datenschutzerklärung:</strong>{" "}
          <a
            href="https://stripe.com/de/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://stripe.com/de/privacy
          </a>
          <br />
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO).
          <br />
          <strong>Grundlage Drittlandtransfers:</strong> Data Privacy Framework (DPF).
        </P>

        <H2>Bereitstellung des Onlineangebots und Webhosting</H2>
        <P>
          Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur Verfügung stellen
          zu können. Zu diesem Zweck verarbeiten wir die IP-Adresse des Nutzers, die notwendig ist, um
          die Inhalte und Funktionen unserer Online-Dienste an den Browser oder das Endgerät der Nutzer
          zu übermitteln.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
        </P>
        <P>
          <strong>Bereitstellung Onlineangebot auf gemietetem Speicherplatz:</strong> Für die
          Bereitstellung unseres Onlineangebotes nutzen wir Speicherplatz, Rechenkapazität und Software,
          die wir von einem entsprechenden Serveranbieter (Webhoster) mieten oder anderweitig beziehen.
        </P>
        <P>
          <strong>Erhebung von Zugriffsdaten und Logfiles:</strong> Der Zugriff auf unser Onlineangebot
          wird in Form von sogenannten „Server-Logfiles" protokolliert. Zu den Serverlogfiles können die
          Adresse und der Name der abgerufenen Webseiten und Dateien, Datum und Uhrzeit des Abrufs,
          übertragene Datenmengen, Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das
          Betriebssystem des Nutzers, Referrer URL und im Regelfall IP-Adressen und der anfragende
          Provider gehören. Logfile-Informationen werden für die Dauer von maximal 30 Tagen gespeichert
          und danach gelöscht oder anonymisiert.
        </P>

        <H2>Einsatz von Cookies</H2>
        <P>
          Unter dem Begriff „Cookies" werden Funktionen, die Informationen auf Endgeräten der Nutzer
          speichern und aus ihnen auslesen, verstanden. Cookies können ferner in Bezug auf unterschiedliche
          Anliegen Einsatz finden, etwa zu Zwecken der Funktionsfähigkeit, der Sicherheit und des Komforts
          von Onlineangeboten sowie der Erstellung von Analysen der Besucherströme. Wir verwenden Cookies
          gemäß den gesetzlichen Vorschriften. Dazu holen wir, wenn erforderlich, vorab die Zustimmung
          der Nutzer ein. Ist eine Zustimmung nicht notwendig, setzen wir auf unsere berechtigten Interessen.
        </P>
        <P>
          <strong>Speicherdauer:</strong>
        </P>
        <UL>
          <li>
            <strong>Temporäre Cookies (Session-Cookies):</strong> Temporäre Cookies werden spätestens
            gelöscht, nachdem ein Nutzer ein Onlineangebot verlassen und sein Endgerät geschlossen hat.
          </li>
          <li>
            <strong>Permanente Cookies:</strong> Permanente Cookies bleiben auch nach dem Schließen des
            Endgeräts gespeichert. Die Speicherdauer kann bis zu zwei Jahre betragen.
          </li>
        </UL>
        <P>
          <strong>Allgemeine Hinweise zum Widerruf und Widerspruch (Opt-out):</strong> Nutzer können
          die von ihnen abgegebenen Einwilligungen jederzeit widerrufen und zudem einen Widerspruch
          gegen die Verarbeitung entsprechend den gesetzlichen Vorgaben, auch mittels der
          Privatsphäre-Einstellungen ihres Browsers, erklären.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO);
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
        </P>

        <H2>Kontakt- und Anfrageverwaltung</H2>
        <P>
          Bei der Kontaktaufnahme mit uns (z. B. per Kontaktformular, E-Mail oder via soziale Medien)
          sowie im Rahmen bestehender Nutzer- und Geschäftsbeziehungen werden die Angaben der anfragenden
          Personen verarbeitet, soweit dies zur Beantwortung der Kontaktanfragen und etwaiger angefragter
          Maßnahmen erforderlich ist.
        </P>
        <P>
          <strong>Kontaktformular:</strong> Bei Kontaktaufnahme über unser Kontaktformular, per E-Mail
          oder anderen Kommunikationswegen, verarbeiten wir die uns übermittelten personenbezogenen
          Daten zur Beantwortung und Bearbeitung des jeweiligen Anliegens. Dies umfasst in der Regel
          Angaben wie Name, Kontaktinformationen und gegebenenfalls weitere Informationen, die uns
          mitgeteilt werden und zur angemessenen Bearbeitung erforderlich sind.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO); Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
        </P>

        <H3>Resend</H3>
        <P>
          Für den transaktionalen Versand von E-Mails (z. B. Zusendung Ihres Trauerrede-Entwurfs an die
          von Ihnen angegebene E-Mail-Adresse sowie Weiterleitung von Kontaktanfragen an uns) nutzen
          wir den Dienst Resend.
        </P>
        <P>
          <strong>Dienstanbieter:</strong> Resend, Inc., 2261 Market Street #5039, San Francisco,
          CA 94114, USA.
          <br />
          <strong>Website:</strong>{" "}
          <a
            href="https://resend.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://resend.com
          </a>
          <br />
          <strong>Datenschutzerklärung:</strong>{" "}
          <a
            href="https://resend.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 text-umber hover:text-charcoal"
          >
            https://resend.com/legal/privacy-policy
          </a>
          <br />
          <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen
          (Art. 6 Abs. 1 lit. b DSGVO); Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
          <br />
          <strong>Grundlage Drittlandtransfers:</strong> Standardvertragsklauseln der EU-Kommission.
        </P>

        <H2>Management, Organisation und Hilfswerkzeuge</H2>
        <P>
          Wir setzen Dienstleistungen, Plattformen und Software anderer Anbieter (nachfolgend bezeichnet
          als „Drittanbieter") zu Zwecken der Organisation, Verwaltung, Planung sowie Erbringung unserer
          Leistungen ein. Bei der Auswahl der Drittanbieter und ihrer Leistungen beachten wir die
          gesetzlichen Vorgaben.
        </P>
        <P>
          In diesem Rahmen können personenbezogenen Daten verarbeitet und auf den Servern der
          Drittanbieter gespeichert werden. Hiervon können diverse Daten betroffen sein, die wir
          entsprechend dieser Datenschutzerklärung verarbeiten. Zu diesen Daten können insbesondere
          Stammdaten und Kontaktdaten der Nutzer, Daten zu Vorgängen, Verträgen, sonstigen Prozessen
          und deren Inhalte gehören.
        </P>
        <P>
          <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO).
        </P>

        <H2>Änderung und Aktualisierung</H2>
        <P>
          Wir bitten Sie, sich regelmäßig über den Inhalt unserer Datenschutzerklärung zu informieren.
          Wir passen die Datenschutzerklärung an, sobald die Änderungen der von uns durchgeführten
          Datenverarbeitungen dies erforderlich machen. Wir informieren Sie, sobald durch die Änderungen
          eine Mitwirkungshandlung Ihrerseits (z. B. Einwilligung) oder eine sonstige individuelle
          Benachrichtigung erforderlich wird.
        </P>

        <H2>Begriffsdefinitionen</H2>
        <P>
          In diesem Abschnitt erhalten Sie eine Übersicht über die in dieser Datenschutzerklärung
          verwendeten Begrifflichkeiten. Soweit die Begrifflichkeiten gesetzlich definiert sind, gelten
          deren gesetzliche Definitionen.
        </P>

        <H4>Bestandsdaten</H4>
        <P>
          Bestandsdaten umfassen wesentliche Informationen, die für die Identifikation und Verwaltung
          von Vertragspartnern, Benutzerkonten, Profilen und ähnlichen Zuordnungen notwendig sind.
          Diese Daten können u. a. persönliche und demografische Angaben wie Namen, Kontaktinformationen
          (Adressen, Telefonnummern, E-Mail-Adressen), Geburtsdaten und spezifische Identifikatoren
          beinhalten.
        </P>

        <H4>Inhaltsdaten</H4>
        <P>
          Inhaltsdaten umfassen Informationen, die im Zuge der Erstellung, Bearbeitung und Veröffentlichung
          von Inhalten aller Art generiert werden. Diese Kategorie von Daten kann Texte, Bilder, Videos,
          Audiodateien und andere multimediale Inhalte einschließen.
        </P>

        <H4>Kontaktdaten</H4>
        <P>
          Kontaktdaten sind essentielle Informationen, die die Kommunikation mit Personen oder
          Organisationen ermöglichen. Sie umfassen u. a. Telefonnummern, postalische Adressen und
          E-Mail-Adressen.
        </P>

        <H4>Meta-, Kommunikations- und Verfahrensdaten</H4>
        <P>
          Meta-, Kommunikations- und Verfahrensdaten sind Kategorien, die Informationen über die Art
          und Weise enthalten, wie Daten verarbeitet, übermittelt und verwaltet werden. Sie können
          Angaben zur Dateigröße, dem Erstellungsdatum, dem Autor eines Dokuments und den Änderungshistorien
          beinhalten.
        </P>

        <H4>Nutzungsdaten</H4>
        <P>
          Nutzungsdaten beziehen sich auf Informationen, die erfassen, wie Nutzer mit digitalen
          Produkten, Dienstleistungen oder Plattformen interagieren. Diese Daten umfassen eine breite
          Palette von Informationen, die aufzeigen, wie Nutzer Anwendungen nutzen, welche Funktionen
          sie bevorzugen, wie lange sie auf bestimmten Seiten verweilen.
        </P>

        <H4>Personenbezogene Daten</H4>
        <P>
          „Personenbezogene Daten" sind alle Informationen, die sich auf eine identifizierte oder
          identifizierbare natürliche Person (im Folgenden „betroffene Person") beziehen; als
          identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere
          mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten,
          zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen identifiziert werden
          kann.
        </P>

        <H4>Protokolldaten</H4>
        <P>
          Protokolldaten sind Informationen über Ereignisse oder Aktivitäten, die in einem System oder
          Netzwerk protokolliert wurden. Diese Daten enthalten typischerweise Informationen wie
          Zeitstempel, IP-Adressen, Benutzeraktionen, Fehlermeldungen und andere Details.
        </P>

        <H4>Verantwortlicher</H4>
        <P>
          Als „Verantwortlicher" wird die natürliche oder juristische Person, Behörde, Einrichtung oder
          andere Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.
        </P>

        <H4>Verarbeitung</H4>
        <P>
          „Verarbeitung" ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführte Vorgang
          oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff
          reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das Erheben, das Auswerten,
          das Speichern, das Übermitteln oder das Löschen.
        </P>

        <H4>Vertragsdaten</H4>
        <P>
          Vertragsdaten sind spezifische Informationen, die sich auf die Formalisierung einer Vereinbarung
          zwischen zwei oder mehr Parteien beziehen. Sie dokumentieren die Bedingungen, unter denen
          Dienstleistungen oder Produkte bereitgestellt, getauscht oder verkauft werden.
        </P>

        <H4>Zahlungsdaten</H4>
        <P>
          Zahlungsdaten umfassen sämtliche Informationen, die zur Abwicklung von Zahlungstransaktionen
          zwischen Käufern und Verkäufern benötigt werden. Sie beinhalten Details wie Kreditkartennummern,
          Bankverbindungen, Zahlungsbeträge, Transaktionsdaten, Verifizierungsnummern und Rechnungsinformationen.
        </P>

        <p className="text-sm text-ink/60 pt-12 mt-8 border-t border-umber/10">
          Erstellt mit dem kostenlosen{" "}
          <a
            href="https://datenschutz-generator.de"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Datenschutz-Generator.de von Dr. Thomas Schwenke
          </a>
          .
        </p>
      </div>
    </LegalLayout>
  );
}
